import { createRequiredContext } from '@festina-life/ui/libs'

import type { ConfigurationPersona } from '../uiModels/types'
import type { ViewPreferences } from './types'

type LayoutProviderProps = {
  preferences: ViewPreferences
  persona: ConfigurationPersona
  onChangeView: (nextPreferences: ViewPreferences) => void
  onChangePersona: (nextPersona: ConfigurationPersona) => void
}

const [useLayoutContext, Provider] =
  createRequiredContext<LayoutProviderProps>('LayoutProvider')

export { Provider, useLayoutContext }
